import React, { Component } from "react";
import { Form, Input, Button, message } from 'antd';
import { ajaxManage } from "utils/common";
import Table from "./table";

class App extends Component {
    state = {
        pageData: [],
        pagination: {
            pageNum: 1,
            pageSize: 10
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        ajaxManage({
            url: "/wechat/getPageManageUser",
            data: this.state.pagination
        }).then(res => {
            let pageAccount = res.data || {};
            this.setState({
                pageData: pageAccount.data || [],
                pagination: {
                    current: pageAccount.pageNum,
                    pageSize: pageAccount.pageSize,
                    total: pageAccount.total
                }
            })
        }).catch(err => {
            this.props.history.replace("login");
        })
    }

  	handleSubmit = (e) => {
    	e.preventDefault();
    	this.props.form.validateFields((err, values) => {
      		if (!err) {
        		console.log('Received values of form: ', values);
        		ajaxManage({
                    url: "/wechat/save",
                    data: values
                }).then(res => {
                    message.success("绑定成功！", () => {
                        this.props.form.resetFields();
                    });
                    this.getData();
                }).catch(err => {
                    message.error("绑定失败！");
                })
      		}
    	});
  	}

  	handleReset = () => {
  		this.props.form.resetFields();
  	}

    deleteAccountById = (id) => {
        if(!id){
            message.destroy();
            message.error("账号无效！");
            return false;
        }
        ajaxManage({
            url: "/wechat/deleteManageUser",
            data: {
                ids: id
            }
        }).then(res => {
            message.destroy();
            message.success("删除成功！");
            this.getData();
        }).catch(err => {
            message.destroy();
            message.error("删除失败！");
        })
    }

    handleTableChange = (pagination) => {
        if(pagination.current === this.state.pagination.pageNum){
            return false;
        }
        this.setState({
            pagination: {
                pageNum: pagination.current,
                pageSize: pagination.pageSize
            }
        }, () => {
            this.getData();
        })
    }

  	render() {
    	const { getFieldDecorator } = this.props.form;
        const { pageData, pagination } = this.state;
    	const formItemLayout = {
      		labelCol: {
        		xs: { span: 24 },
        		sm: { span: 8 },
      		},
      		wrapperCol: {
        		xs: { span: 24 },
        		sm: { span: 16 },
      		}
    	};

    	return (
    		<React.Fragment>
				<div className="list-screen">
            		<div className="list-screen-header">
            			<span></span>
						<p>增加账号</p>
            		</div>
            		<Form onSubmit={this.handleSubmit} className="list-screen-form-wrap">
		    			<div className="list-screen-form-center">
		    				<Form.Item {...formItemLayout} label="真实姓名">
					          	{getFieldDecorator('realName', {
                                    rules: [{ required: true, message: '请输入真实姓名！' }]
                                })(
							        <Input placeholder="请输入真实姓名" />
								)}
					        </Form.Item>
                            <Form.Item {...formItemLayout} label="openId">
                                {getFieldDecorator('openId', {
                                    rules: [{ required: true, message: '请输入openid！' }]
                                })(
                                    <Input placeholder="请输入openid" />
                                )}
                            </Form.Item>
		    			</div>
				      	<div className="list-screen-form-btns">
                            <Button htmlType="reset" onClick={this.handleReset}>清空</Button>
				      		<Button type="primary" htmlType="submit">绑定</Button>
				      	</div>
			      	</Form>
            	</div>
                <Table
                    pageData={pageData}
                    pagination={pagination}
                    handleTableChange={this.handleTableChange}
                    deleteAccountById={this.deleteAccountById}
                />
    		</React.Fragment>
		);
	}
}

const WrappedNormalLoginForm = Form.create()(App);

export default WrappedNormalLoginForm;